// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_JSON from "@rescript/runtime/lib/es6/Stdlib_JSON.js";
import * as NetworkUtils from "../../server/NetworkUtils.re.mjs";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as RescriptRelay from "rescript-relay/src/RescriptRelay.re.mjs";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as RelayRuntime from "relay-runtime";

let network = RelayRuntime.Network.create(NetworkUtils.makeFetchQuery());

function makeEnvironmentWithNetwork(network, missingFieldHandlers) {
  return RescriptRelay.Environment.make(network, RescriptRelay.Store.make(new RelayRuntime.RecordSource(), 50, 21600000), undefined, undefined, missingFieldHandlers, undefined, undefined);
}

let environment = makeEnvironmentWithNetwork(network, undefined);

let nonForwardableHeaders = [
  "host",
  "connection",
  "keep-alive",
  "proxy-authenticate",
  "proxy-authorization",
  "proxy-connection",
  "te",
  "trailer",
  "transfer-encoding",
  "upgrade",
  "expect",
  "content-length",
  "content-type"
];

function forwardableHeaders(headers) {
  let headers$1 = Stdlib_JSON.Decode.object(headers);
  if (headers$1 !== undefined) {
    return Object.fromEntries(Stdlib_Array.filterMap(Object.entries(headers$1), param => {
      let name = param[0];
      if (nonForwardableHeaders.includes(name.toLowerCase())) {
        return;
      } else {
        return Stdlib_Option.map(Stdlib_JSON.Decode.string(param[1]), value => [
          name,
          value
        ]);
      }
    }));
  } else {
    return {};
  }
}

function makeServer(onQuery, _request) {
  let network = RelayRuntime.Network.create(NetworkUtils.makeServerFetchQuery(onQuery, forwardableHeaders(_request.headers)));
  return makeEnvironmentWithNetwork(network, undefined);
}

function getRelayEnv(context, ssr) {
  if (ssr) {
    return context.environment;
  } else {
    return environment;
  }
}

export {
  network,
  makeEnvironmentWithNetwork,
  environment,
  nonForwardableHeaders,
  forwardableHeaders,
  makeServer,
  getRelayEnv,
}
/* network Not a pure module */
